import ReactGA from 'react-ga';


const EventTrack = (category, action, label) => {
    ReactGA.event({
        category: category,
        action: action,
        label: label,
    })
}

export default EventTrack